import React from 'react'
import { Pagination } from 'react-bootstrap'
import { LinkContainer } from 'react-router-bootstrap'

const PaginateItem = ({ pagesitem, pageitem }) => {
  return (
    pagesitem > 1 && (
      <Pagination size='sm' className='my-2 themed-pagination'>
        {[...Array(pagesitem).keys()].map((x) => (
          <LinkContainer key={x + 1} to={`/pageitem/${x + 1}`}>
            <Pagination.Item active={x + 1 === pageitem}>
              {x + 1}
            </Pagination.Item>
          </LinkContainer>
        ))}
      </Pagination>
    )
  )
}

export default PaginateItem
